import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { BrandLogo } from "@/components/BrandLogo";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ds";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState<"loading" | "ok" | "error">("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) { setState("error"); setMessage("This verification link is missing a token."); return; }
    api.verifyEmail(token).then(() => setState("ok")).catch((e) => { setState("error"); setMessage(formatApiError(e)); });
  }, [token]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-sm rounded-xl border border-slate-200 bg-white p-8 text-center shadow-sm" data-testid="verify-email">
        <div className="mb-4 flex items-center justify-center">
          <BrandLogo className="h-9" />
        </div>
        {state === "loading" && <div className="flex flex-col items-center gap-3 py-4 text-slate-500"><Loader2 className="h-6 w-6 animate-spin text-blue-600" /><p className="text-sm">Verifying your email…</p></div>}
        {state === "ok" && (
          <div className="flex flex-col items-center gap-3 py-4">
            <CheckCircle2 className="h-10 w-10 text-emerald-600" />
            <p className="font-medium text-slate-900">Email verified</p>
            <p className="text-sm text-slate-500">Your email address has been confirmed.</p>
            <Link to="/app/dashboard" className="w-full"><Button className="w-full" data-testid="verify-continue">Continue</Button></Link>
          </div>
        )}
        {state === "error" && (
          <div className="flex flex-col items-center gap-3 py-4">
            <XCircle className="h-10 w-10 text-red-600" />
            <p className="font-medium text-slate-900">Verification failed</p>
            <p className="text-sm text-slate-500">{message}</p>
            <Link to="/login" className="w-full"><Button variant="outline" className="w-full">Back to sign in</Button></Link>
          </div>
        )}
      </div>
    </div>
  );
}
